var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSurvey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4897_1133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6453 15.7485L15.728 11.6658L5.85323 1.79106L1.77051 5.87378L11.6453 15.7485ZM16.1096 12.385L12.3644 16.1302L17.9795 18L16.1096 12.385ZM0.514772 4.62344L1.22292 5.33159L5.31104 1.24347L4.60289 0.535326C3.88955 -0.178442 2.73279 -0.178442 2.01945 0.535326L0.514772 2.04001C-0.193377 2.75572 -0.193377 3.90795 0.514772 4.62344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4897_1133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSurvey);
export default __webpack_public_path__ + "static/media/ico-survey.18123c7f31084f527b7745599a888f11.svg";
export { ForwardRef as ReactComponent };